module.exports = __webpack_public_path__ + "static/media/shortunderline.1c381565.svg";